/**
 * @desc 导出箱码规格
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierBoxGaugeUpdateRecord.exporting.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierBoxGaugeUpdateRecord/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
